<template>
  <div class="avecor-table" >
    <v-tabs
      fixed-tabs
      dark
      height="30"
      dense
      
      class="promotion-tabs"
      background-color="#136DF5"
      style="position:fixed;top:35px;z-index:20;border-bottom:1px solid orange;" 
    >
      <v-tabs-slider color="#FFF" ></v-tabs-slider>
      <v-tab @click="setPersons()" >Henkilöt</v-tab>
      <!-- <v-tab @click="selectedStaffTab = 'persons_old'">Henkilöt</v-tab> -->
      
      <v-tab @click="selectedStaffTab = 'signatures';" >Allekirjoitukset</v-tab>
    </v-tabs>
    <div v-if="selectedStaffTab === 'persons'" style="padding-top:30px;">
      <v-toolbar style="border-bottom:1px solid #ccc;position:fixed;top:62px;width:100%;background:#FFF !important;z-index:20"  class=" pr-5" flat dense>
        <v-toolbar-title >Henkilöstö</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-col cols="2">
          <v-text-field
            v-model="staffSearchTerm"
            class="table-search avecor-select"
            label="Etsi henkilöstöä tästä"
            single-line
            hide-details
            autocomplete="off"
          ></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="4"  class="text-right pt-4">
          <!-- <v-switch
              v-model="showExitedStaff"
              label="Näytä poistuneet?"
              color="orange darken-3"
              hide-details
          ></v-switch> -->
          <v-btn-toggle  dense :multiple="false" :mandatory="true" style="border:1px #ccc solid; " v-model="activeExitFilter">
            <v-btn height="30" class="avecor-button-global avecor-button-group-button" value="active">
              Aktiiviset
            </v-btn>
            <v-btn height="30" class="avecor-button-global avecor-button-group-button" value="exited">
              Poistuneet
            </v-btn>
          </v-btn-toggle>
          
          <v-btn v-if="user.uid==='gRkaRl92OGXQIzaJy9E0YiOKgSf1'" class="avecor-button-global add-button mb-2 ml-10 mt-1" color="#000000" @click="addStaffDialog=true" dark >Lisää henkilö</v-btn>
          <v-btn v-if="user.uid==='gRkaRl92OGXQIzaJy9E0YiOKgSf1'" class="avecor-button-global add-button mb-2 ml-2 mt-1" color="#000000" @click="addMarginGoals()" dark >Lisää katetavoitteet</v-btn>
          <AddStaff @close="addStaffDialog=false" :visible="addStaffDialog" ></AddStaff>
        </v-col>
      </v-toolbar>
      <v-row no-gutters style="border-bottom:1px solid #ccc;background:#EEEEEE;font-weight:600;margin-bottom:100px;height:50px;" class="products-table-headers-sticky">
        <v-col cols="6">
          <v-row no-gutters>
            <!-- <v-col cols="1" class="orders-custom-header pl-2">Toiminnot</v-col> -->
            <v-col cols="1" class="orders-custom-header text-center">Lisätty pvm</v-col>
            <v-col cols="1" class="orders-custom-header pl-3 pr-2" >Etunimi</v-col>
            <v-col cols="1" class="orders-custom-header pl-0 pr-2" >Sukunimi</v-col>
            <v-col cols="1" class="orders-custom-header pl-0 pr-2" >Sähköposti</v-col>
            <v-col cols="1" class="orders-custom-header pl-0 pr-2" >Puhelinnumero</v-col>
            <v-col cols="1" class="orders-custom-header pl-0 pr-2" >Osoite</v-col>
            <v-col cols="1" class="orders-custom-header pl-0 pr-2" >Netvisor id</v-col>
            <v-col cols="1" class="orders-custom-header"><span v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1' || user.uid === 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2'">Provisio vanha</span></v-col>
            <v-col cols="1" class="orders-custom-header"><span v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1' || user.uid === 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2'">Prov all 1.99</span></v-col>
            <v-col cols="1" class="orders-custom-header"><span v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1' || user.uid === 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2'">Prov 2-2.49</span></v-col>
            <v-col cols="1" class="orders-custom-header"><span v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1' || user.uid === 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2'">Prov yli 2.50</span></v-col>
            <v-col cols="1" class="orders-custom-header"><span v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1' || user.uid === 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2'">Kulukatto</span></v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row no-gutters>
            <v-col cols="1" class="orders-custom-header pl-0 pr-2" >Rooli</v-col>
            <v-col cols="2" class="orders-custom-header pl-0 pr-2" >IT-laitteet</v-col>
            <v-col cols="1" class="orders-custom-header">Admin</v-col>
            <v-col cols="1" class="orders-custom-header">Exit</v-col>
            <v-col cols="1" class="orders-custom-header">Logogear</v-col>
            <v-col cols="1" class="orders-custom-header pr-2">Disabloi raportti näkymä</v-col>
            <v-col cols="1" class="orders-custom-header pr-2">Disabloi tilaukset näkymä</v-col>
            <v-col cols="1" class="orders-custom-header pr-2">Viikkoraportointi</v-col>
            <!-- <v-col cols="1" class="orders-custom-header pr-2">Tuotteet näkymä</v-col> -->
            <v-col cols="1" class="orders-custom-header pr-2">Henkilöstö näkymä</v-col>
            <v-col cols="1" class="orders-custom-header pr-2">Kaikkien katteet (sales)</v-col>
            <!-- <v-col cols="1" class="orders-custom-header pr-2">Tukkurit</v-col> -->
            <v-col cols="1" class="orders-custom-header pr-2">Kaikkien tilaukset (sales)</v-col>
            <!-- <v-col cols="1" class="orders-custom-header">Kaikkien tiedostot (sales)</v-col> -->
            <!-- <v-col cols="1" class="orders-custom-header">Tilauksista vastaava</v-col> -->
            
            
          </v-row>
        </v-col>
      </v-row>
      <div style="margin-top:120px;margin-bottom:120px;border-top:1px solid #ccc;" :key="staffTableKey">
        <v-row no-gutters v-for="person in getStaff" :key="person.id"  style="border-bottom:1px solid #ccc;">
          <v-col cols="6">
            <v-row no-gutters >
              <!-- <v-col cols="1" class="products-custom-field pl-4">
                
              </v-col> -->
              <v-col cols="1" class="products-custom-field pl-1 pr-2" >
                
                <div style="display:inline-block" :class="staff[user.uid].isAdmin && person.role === 'sales' ? 'pt-1 pl-2' : 'pt-3 pl-2'">{{ person.created_at ? customFormatter(person.created_at) : '' }}</div>
                <div style="min-width:20px;" class="text-center">
                  <v-icon 
                    :size="settings.tableSelectIconsSize"
                    v-if="staff[user.uid].isAdmin && (person.role === 'sales'|| person.role === 'sales-exist')"
                    @click="expandedPersons.includes(person.id) ? expandedPersons = expandedPersons.filter(pId => {return pId !== person.id}) : expandedPersons.push(person.id)"
                    style="padding-left:3px;padding-top:0px;"
                  >
                    far fa-money-bill-alt
                  </v-icon>
                </div>
                <!-- <v-text-field
                    style="padding-top:6px !important;display:inline-block"
                    slot="activator"
                    
                    class="avecor-date-picker"  
                    :value="person.created_at ? customFormatter(person.created_at) : ''"
                    readonly
                    hide-details
                ></v-text-field> -->
              </v-col>
              <v-col cols="1" class="products-custom-field text-center">
                <v-text-field
                  v-model="person.firstName"
                  @change="v => inlineSaveNew(person.id,'firstName',v)"
                  class="avecor-select"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="products-custom-field pl-0 pr-2" >
                <v-text-field
                  v-model="person.lastName"
                  @change="v => inlineSaveNew(person.id,'lastName',v)"
                  class="avecor-select"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="products-custom-field pl-0 pr-2" >
                <v-text-field
                  v-model="person.email"
                  @change="v => inlineSaveNew(person.id,'email',v)"
                  class="avecor-select"
                  disabled
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="products-custom-field pl-0 pr-2" >
                <v-text-field
                  v-model="person.phone"
                  @change="v => inlineSaveNew(person.id,'phone',v)"
                  class="avecor-select"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="products-custom-field pl-0 pr-2" >
                <v-text-field
                  v-model="person.address"
                  @change="v => inlineSaveNew(person.id,'address',v)"
                  class="avecor-select pr-3"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="products-custom-field pl-0 pr-2" >
                <v-text-field
                  v-model="person.netvisorKey"
                  @change="v => inlineSaveNew(person.id,'netvisorKey',v)"
                  class="avecor-select "
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="products-custom-field">
                <v-text-field
                v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1' || user.uid === 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2'"
                  v-model="person.commissionRate"
                  @change="v => inlineSaveNew(person.id,'commissionRate',v)"
                  class="avecor-select "
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="products-custom-field">
                <v-text-field
                v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1' || user.uid === 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2'"
                  v-model="person.commissionRate_level1"
                  @change="v => inlineSaveNew(person.id,'commissionRate_level1',v)"
                  class="avecor-select "
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="products-custom-field">
                <v-text-field
                v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1' || user.uid === 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2'"
                  v-model="person.commissionRate_level2"
                  @change="v => inlineSaveNew(person.id,'commissionRate_level2',v)"
                  class="avecor-select "
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="products-custom-field">
                <v-text-field
                v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1' || user.uid === 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2'"
                  v-model="person.commissionRate_level3"
                  @change="v => inlineSaveNew(person.id,'commissionRate_level3',v)"
                  class="avecor-select "
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="1" class="products-custom-field">
                <v-text-field
                  v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1' || user.uid === 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2'"
                  v-model="person.expenseLimit"
                  @change="v => inlineSaveNew(person.id,'expenseLimit',v)"
                  class="avecor-select "
                  hide-details
                ></v-text-field>
              </v-col>
              
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-row no-gutters>
              <v-col cols="1" class="products-custom-field pl-0 pr-2" >
                <v-autocomplete
                  v-model="person.role"
                  :items="settings.roles"
                  @change="v => inlineSaveNew(person.id,'role',v)"
                  persistent-hint
                  item-text="text"
                  item-value="value"
                  class="avecor-select"
                  hide-details
                />
              </v-col>
              <v-col cols="2" class="products-custom-field pl-0 pr-2" >
                <v-textarea
                  :auto-grow="true"
                  @change="v => inlineSaveNew(person.id,'deviceInfo',v)"
                  rows=1
                  placeholder=" "
                  v-model="person.deviceInfo"
                  class="avecor-select"
                  hide-details
                ></v-textarea>
              </v-col>
              <v-col cols="1" class="products-custom-field pt-3">
                <i v-if="person.isAdmin" :style="'color:blue;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'isAdmin',false)" class="far fa-check-square pl-1 pr-2"></i>
                <i v-else :style="'color:#555;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'isAdmin',true)" class="far fa-square pl-1 pr-2"></i>
                <!-- <v-checkbox v-model="props.item.isAdmin" @change="inlineSave(props.item)" class="avecor-table-checkbox" style="margin-top:0px important!"></v-checkbox> -->
              </v-col>
              <v-col cols="1" class="products-custom-field pt-3">
                <i v-if="person.isExit" :style="'color:blue;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'isExit',false)" class="far fa-check-square pl-1 pr-2"></i>
                <i v-else :style="'color:#555;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'isExit',true)" class="far fa-square pl-1 pr-2"></i>
              </v-col>
              <v-col cols="1" class="products-custom-field pt-3">
                <i v-if="person.isLogogear" :style="'color:blue;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'isLogogear',false)" class="far fa-check-square pl-1 pr-2"></i>
                <i v-else :style="'color:#555;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'isLogogear',true)" class="far fa-square pl-1 pr-2"></i>
              </v-col>
              <v-col cols="1" class="products-custom-field pt-3">
                <span v-if="person.role !== 'office' && !person.isAdmin">
                  <i v-if="person.disableReportView" :style="'color:blue;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'disableReportView',false)" class="far fa-check-square pl-1 pr-2"></i>
                  <i v-else :style="'color:#555;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'disableReportView',true)" class="far fa-square pl-1 pr-2"></i>
                </span>
              </v-col>
              <v-col cols="1" class="products-custom-field pt-3">
                <span v-if="person.role !== 'office' && !person.isAdmin">
                  <i v-if="person.disableOrdersView" :style="'color:blue;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'disableOrdersView',false)" class="far fa-check-square pl-1 pr-2"></i>
                  <i v-else :style="'color:#555;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'disableOrdersView',true)" class="far fa-square pl-1 pr-2"></i>
                </span>
              </v-col>
              <v-col cols="1" class="products-custom-field pt-3">
                <span v-if="person.role == 'sales'">
                  <i v-if="person.weekReportingRequired" :style="'color:blue;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'weekReportingRequired',false)" class="far fa-check-square pl-1 pr-2"></i>
                  <i v-else :style="'color:#555;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'weekReportingRequired',true)" class="far fa-square pl-1 pr-2"></i>
                </span>
              </v-col>
              <!-- <v-col cols="1" class="products-custom-field pt-3">
                <span v-if="person.role !== 'office' && !person.isAdmin">
                  <i v-if="person.productsAccess" :style="'color:blue;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'productsAccess',false)" class="far fa-check-square pl-1 pr-2"></i>
                  <i v-else :style="'color:#555;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'productsAccess',true)" class="far fa-square pl-1 pr-2"></i>
                </span>
              </v-col> -->
              <v-col cols="1" class="products-custom-field pt-3">
                <span v-if="person.role !== 'office' && !person.isAdmin">
                  <i v-if="person.staffAccess" :style="'color:blue;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'staffAccess',false)" class="far fa-check-square pl-1 pr-2"></i>
                  <i v-else :style="'color:#555;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'staffAccess',true)" class="far fa-square pl-1 pr-2"></i>
                </span>
              </v-col>
              <v-col cols="1" class="products-custom-field pt-3">
                <span v-if="person.role !== 'office' && !person.isAdmin">
                  <i v-if="person.marginsAccess" :style="'color:blue;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'marginsAccess',false)" class="far fa-check-square pl-1 pr-2"></i>
                  <i v-else :style="'color:#555;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'marginsAccess',true)" class="far fa-square pl-1 pr-2"></i>
                </span>
              </v-col>
              <v-col cols="1" class="products-custom-field pt-3">
                <span v-if="person.role !== 'office' && !person.isAdmin">
                  <i v-if="person.allOrdersAccess" :style="'color:blue;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'allOrdersAccess',false)" class="far fa-check-square pl-1 pr-2"></i>
                  <i v-else :style="'color:#555;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'allOrdersAccess',true)" class="far fa-square pl-1 pr-2"></i>
                </span>
              </v-col>
              <!-- <v-col cols="1" class="products-custom-field pt-3">
                <span v-if="person.role !== 'office' && !person.isAdmin">
                  <i v-if="person.wholesaleCompaniesAccess" :style="'color:blue;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'wholesaleCompaniesAccess',false)" class="far fa-check-square pl-1 pr-2"></i>
                  <i v-else :style="'color:#555;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'wholesaleCompaniesAccess',true)" class="far fa-square pl-1 pr-2"></i>
                </span>
              </v-col> -->
              <!-- <v-col cols="1" class="products-custom-field pt-3">
                <i v-if="person.allFilesAccess" :style="'color:blue;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'allFilesAccess',false)" class="far fa-check-square pl-1 pr-2"></i>
                <i v-else :style="'color:#555;font-size:14px;cursor:pointer;'" @click="inlineSaveNew(person.id,'allFilesAccess',true)" class="far fa-square pl-1 pr-2"></i>
              </v-col> -->
              <!-- <v-col cols="1" class="products-custom-field">
                <v-autocomplete
                  v-model="person.orderResponsibility"
                  :items="getOfficeStaff"
                  @change="v => inlineSaveNew(person.id,'orderResponsibility',v)"
                  persistent-hint
                  item-text="text"
                  item-value="id"
                  class="avecor-select"
                  hide-details
                  :disabled="disabledRoleSelection(person.id)"
                />
              </v-col> -->
              
            </v-row>
          </v-col>
          <v-col cols="12" v-if="expandedPersons.includes(person.id)" style="background:#fafafa;border-top:1px solid #ccc;">
            <v-row no-gutters v-if="user.uid==='gRkaRl92OGXQIzaJy9E0YiOKgSf1'">
              <v-col cols="12" class="text-center">
                <v-btn  class="avecor-button-global add-button mt-2 mb-2 " x-small color="#000000" @click="addYear(person)" dark >
                  Lisää vuosi
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters >
              <v-col cols="12" class=" pl-2 text-left" style="background:#555;color:#fff;"><h4>{{person.firstName}} katetavoitteet</h4></v-col>
            </v-row>
            <v-row no-gutters >
              <v-col cols="1" class="py-1 text-center" >
                <v-row no-gutters >
                  <v-col  cols="12" style="font-weight:bold;font-size:12px;" class="px-2 text-center">Vuosi</v-col>
                </v-row>
                <v-row no-gutters v-for="(year) in years" :key="person.id+'-margin-goal-header'+year">
                  <v-col v-if="person.marginGoals && person.marginGoals[year]" cols="12" class="text-center"  style="font-weight:bold;font-size:12px;height:25px;border-top:1px solid #ccc;">
                    {{year}}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="11" class="py-1 text-center" >
                <v-row no-gutters style="font-weight:bold;font-size:12px;">
                  <v-col cols="1" class="px-2 text-left" >Tammikuu</v-col>
                  <v-col cols="1" class="px-2 text-left" >Helmikuu</v-col>
                  <v-col cols="1" class="px-2 text-left" >Maaliskuu</v-col>
                  <v-col cols="1" class="px-2 text-left" >Huhtikuu</v-col>
                  <v-col cols="1" class="px-2 text-left" >Toukokuu</v-col>
                  <v-col cols="1" class="px-2 text-left" >Kesäkuu</v-col>
                  <v-col cols="1" class="px-2 text-left" >Heinäkuu</v-col>
                  <v-col cols="1" class="px-2 text-left" >Elokuu</v-col>
                  <v-col cols="1" class="px-2 text-left" >Syyskuu</v-col>
                  <v-col cols="1" class="px-2 text-left" >Lokakuu</v-col>
                  <v-col cols="1" class="px-2 text-left" >Marraskuu</v-col>
                  <v-col cols="1" class="px-2 text-left" >Joulukuu</v-col>
                </v-row>
                <v-row no-gutters v-for="(year) in years" :key="person.id+'-margin-goal-'+year" >
                  <v-col v-if="person.marginGoals && person.marginGoals[year]" cols="1" class="pl-2 pr-8" v-for="month in 12" :key="person.id+'-margin-goal-'+year+month" style="border-top:1px solid #ccc;">
                    <input placeholder="" :value="person.marginGoals[year][month]" type="text"  style="line-height:16px;font-size:11px;background:#eee;width:100%;padding-left:5px;" 
                      @change="v => inlineSaveGoalData(person.id,'marginGoals',year,month,v,true)">
                    <!-- <v-text-field
                      v-model="person.marginGoals[year][month]"
                      @change="inlineSave(person)"
                      class="avecor-select hide-field-details"
                      hide-details                    ></v-text-field> -->
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters >
              <v-col cols="12" class=" pl-2 text-left" style="background:#555;color:#fff;"><h4>{{person.firstName}} myyntitavoitteet</h4></v-col>
              <!-- <v-col cols="12" class="my-2 pl-2 text-left" style="background:#ccc;"><span class="title">Myynti</span></v-col> -->
            </v-row>
            <v-row no-gutters >
              <v-col cols="1" class="py-1 text-center" >
                <v-row no-gutters >
                  <v-col  cols="12" style="font-weight:bold;font-size:12px;" class="px-2 text-center">Vuosi</v-col>
                </v-row>
                <v-row no-gutters v-for="(year) in years" :key="person.id+'-sales-goal-header'+year">
                  <!-- <v-col v-if="person.goals[year]" cols="12" class="pa-2 text-center">
                    <v-text-field
                      :value="year"
                      disabled
                      class="avecor-select hide-field-details"
                    ></v-text-field>
                  </v-col> -->
                  <v-col v-if="person.goals && person.goals[year]" cols="12" class="text-center"  style="font-weight:bold;font-size:12px;height:25px;border-top:1px solid #ccc;">
                    {{year}}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="11" class="py-1 text-center" >
                <v-row no-gutters style="font-weight:bold;font-size:12px;">
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Tammikuu</v-col>
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Helmikuu</v-col>
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Maaliskuu</v-col>
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Huhtikuu</v-col>
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Toukokuu</v-col>
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Kesäkuu</v-col>
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Heinäkuu</v-col>
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Elokuu</v-col>
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Syyskuu</v-col>
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Lokakuu</v-col>
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Marraskuu</v-col>
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Joulukuu</v-col>
                </v-row>
                <v-row no-gutters v-for="(year) in years" :key="person.id+'-sales-goal-'+year">
                  <v-col v-if="person.goals[year]" cols="1" class="pl-2 pr-8" v-for="month in 12" :key="person.id+'-sales-goal-'+year+month" style="border-top:1px solid #ccc;">
                    <input placeholder="" :value="person.goals[year][month]" type="text"  style="line-height:16px;font-size:11px;background:#eee;width:100%;padding-left:5px;" 
                      @change="v => inlineSaveGoalData(person.id,'goals',year,month,v,true)">
                    <!-- <v-text-field
                      v-model="person.goals[year][month]"
                      @change="inlineSave(person)"
                      class="avecor-select hide-field-details"
                    ></v-text-field> -->
                  </v-col>
                  
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters >
              <v-col cols="12" class=" pl-2 text-left" style="background:#555;color:#fff;"><h4>{{person.firstName}} katekerrointavoitteet</h4></v-col>
              
            </v-row>
            <v-row no-gutters >
              <v-col cols="1" class="py-1 text-center" >
                <v-row no-gutters >
                  <v-col  cols="12" style="font-weight:bold;font-size:12px;" class="px-2 text-center">Vuosi</v-col>
                </v-row>
                <v-row no-gutters v-for="(year) in years" :key="person.id+'-margin-rate-goal-header'+year">
                  <v-col v-if="person.goals && person.marginRateGoals[year]" cols="12" class="text-center"  style="font-weight:bold;font-size:12px;height:25px;border-top:1px solid #ccc;">
                    {{year}}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="11" class="py-1 text-center" >
                <v-row no-gutters style="font-weight:bold;font-size:12px;">
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Tammikuu</v-col>
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Helmikuu</v-col>
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Maaliskuu</v-col>
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Huhtikuu</v-col>
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Toukokuu</v-col>
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Kesäkuu</v-col>
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Heinäkuu</v-col>
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Elokuu</v-col>
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Syyskuu</v-col>
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Lokakuu</v-col>
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Marraskuu</v-col>
                  <v-col cols="1" class="px-2 text-left" style="font-weight:bold">Joulukuu</v-col>
                </v-row>
                <v-row no-gutters v-for="(year) in years" :key="person.id+'-margin-rate-goal-'+year">
                  <v-col v-if="person.marginRateGoals[year]" cols="1" class="pl-2 pr-8" v-for="month in 12" :key="person.id+'-margin-rate-goal-'+year+month" style="border-top:1px solid #ccc;">
                    <input placeholder="" :value="person.marginRateGoals[year][month]" type="text"  style="line-height:16px;font-size:11px;background:#eee;width:100%;padding-left:5px;" 
                      @change="v => inlineSaveGoalData(person.id,'marginRateGoals',year,month,v,true)">
                    <!-- <v-text-field
                      v-model="person.goals[year][month]"
                      @change="inlineSave(person)"
                      class="avecor-select hide-field-details"
                    ></v-text-field> -->
                  </v-col>
                  
                </v-row>
              </v-col>
            </v-row>

          </v-col>
        </v-row>
      </div>
    </div>
    <div v-if="selectedStaffTab === 'persons_old'" style="padding-top:30px;">
      <v-toolbar style="border-bottom:1px solid #ccc" class=" pr-5" flat dense>
        <v-toolbar-title >Henkilöstö</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-col cols="2">
          <v-text-field
            v-model="staffSearchTerm"
            class="table-search avecor-select"
            label="Etsi henkilöstöä tästä"
            single-line
            hide-details
            autocomplete="off"
          ></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="4"  class="text-right pt-4">
          <!-- <v-switch
              v-model="showExitedStaff"
              label="Näytä poistuneet?"
              color="orange darken-3"
              hide-details
          ></v-switch> -->
          <v-btn-toggle  dense :multiple="false" :mandatory="true" style="border:1px #ccc solid; " v-model="activeExitFilter">
            <v-btn height="30" class="avecor-button-global avecor-button-group-button" value="active">
              Aktiiviset
            </v-btn>
            <v-btn height="30" class="avecor-button-global avecor-button-group-button" value="exited">
              Poistuneet
            </v-btn>
          </v-btn-toggle>
          
          <v-btn v-if="user.uid==='gRkaRl92OGXQIzaJy9E0YiOKgSf1'" class="avecor-button-global add-button mb-2 ml-10 mt-1" color="#000000" @click="addStaffDialog=true" dark >Lisää henkilö</v-btn>
          <v-btn v-if="user.uid==='gRkaRl92OGXQIzaJy9E0YiOKgSf1'" class="avecor-button-global add-button mb-2 ml-2 mt-1" color="#000000" @click="addMarginGoals()" dark >Lisää katetavoitteet</v-btn>
          <AddStaff @close="addStaffDialog=false" :visible="addStaffDialog" ></AddStaff>
        </v-col>
      </v-toolbar>
      <div>
      <v-data-table
        :headers="headers"
        :items="getStaff"
        hide-default-footer
        :search="staffSearchTerm"
        disable-pagination
        fixed-header
        height="87.4vh"
        style="padding-top:00px;border-bottom:1px solid #ccc"
        :dense="true"
      >
        <template v-slot:item="props">
          <tr style="height:25px;" class="hide-field-details" >
            <td class="text-center" style="width:40px;">
            <!--   <v-icon 
                :size="settings.tableSelectIconsSize"
                @click="deleteItem(props.item)"
              >
                far fa-trash-alt
              </v-icon>
            -->
              <v-icon 
                  :size="settings.tableSelectIconsSize"
                  v-if="staff[user.uid].isAdmin || (props.item.role === 'sales'|| props.item.role === 'sales-exist')"
                  @click="props.isExpanded ? props.expand(false) : props.expand(true)"
                  style="padding-left:3px;"
                >
                  far fa-money-bill-alt
              </v-icon>
            </td>
            <td style="min-width:50px">
              <v-text-field
                  slot="activator"
                  class="avecor-date-picker"  
                  :value="props.item.created_at ? customFormatter(props.item.created_at) : ''"
                  readonly
              ></v-text-field>
            </td>
            <td style="min-width:100px;">
              <v-text-field
                v-model="props.item.firstName"
                @change="inlineSave(props.item)"
                class="avecor-select"
              ></v-text-field>
            </td>
            <td style="min-width:100px;">
              <v-text-field
                v-model="props.item.lastName"
                @change="inlineSave(props.item)"
                class="avecor-select"
              ></v-text-field>
            </td>
            <td style="min-width:150px;">
              <v-text-field
                v-model="props.item.email"
                @change="inlineSave(props.item)"
                class="avecor-select"
                disabled
              ></v-text-field>
            </td>
            <td style="min-width:150px;">
              <v-text-field
                v-model="props.item.phone"
                @change="inlineSave(props.item)"
                class="avecor-select"
              ></v-text-field>
            </td>
            <td style="min-width:150px;">
              <v-text-field
                v-model="props.item.address"
                @change="inlineSave(props.item)"
                class="avecor-select"
              ></v-text-field>
            </td>
            <td style="min-width:100px;" >
              <v-text-field
                v-model="props.item.netvisorKey"
                @change="inlineSave(props.item)"
                class="avecor-select pl-5"
              ></v-text-field>
            </td>
            <td style="min-width:150px;">
              <v-textarea
                :auto-grow="true"
                @change="inlineSave(props.item)"
                rows=1
                placeholder=" "
                v-model="props.item.deviceInfo"
                class="avecor-select"
              ></v-textarea>
            </td>
            <td style="min-width:100px;">
              <v-autocomplete
                v-model="props.item.role"
                :items="settings.roles"
                @change="inlineSave(props.item)"
                persistent-hint
                item-text="text"
                item-value="value"
                class="avecor-select"
              />
            </td>
            <td>
              <v-checkbox v-model="props.item.isAdmin" @change="inlineSave(props.item)" class="avecor-table-checkbox" style="margin-top:0px important!"></v-checkbox>
            </td>
            <!-- <td>
              <v-checkbox v-model="props.item.promotionsAccess" @change="inlineSave(props.item)" class="avecor-table-checkbox" ></v-checkbox>
            </td> -->
            <td>
              <v-checkbox v-model="props.item.isExit" @change="inlineSave(props.item)" class="avecor-table-checkbox" style="margin-top:0px important!"></v-checkbox>
            </td>
            <td>
              <v-checkbox v-model="props.item.disableReportView" @change="inlineSave(props.item)" class="avecor-table-checkbox" style="margin-top:0px important!"></v-checkbox>
            </td>
            <td>
              <v-checkbox v-model="props.item.disableOrdersView" @change="inlineSave(props.item)" class="avecor-table-checkbox" style="margin-top:0px important!"></v-checkbox>
            </td>
            
            <td>
              <v-checkbox v-model="props.item.weekReportingRequired" @change="inlineSave(props.item)" class="avecor-table-checkbox" style="margin-top:0px important!"></v-checkbox>
            </td>
            <td>
              <v-checkbox v-model="props.item.productsAccess" @change="inlineSave(props.item)" class="avecor-table-checkbox" style="margin-top:0px important!"></v-checkbox>
            </td>
            <td>
              <v-checkbox v-model="props.item.staffAccess" @change="inlineSave(props.item)" class="avecor-table-checkbox" style="margin-top:0px important!"></v-checkbox>
            </td>
            <td>
              <v-checkbox v-model="props.item.marginsAccess" @change="inlineSave(props.item)" class="avecor-table-checkbox" style="margin-top:0px important!"></v-checkbox>
            </td>
            <td>
              <v-checkbox v-model="props.item.allOrdersAccess" @change="inlineSave(props.item)" class="avecor-table-checkbox" style="margin-top:0px important!"></v-checkbox>
            </td>
            <td>
              <v-checkbox v-model="props.item.allFilesAccess" @change="inlineSave(props.item)" class="avecor-table-checkbox" style="margin-top:0px important!"></v-checkbox>
            </td>
            <td>
              <v-autocomplete
                v-model="props.item.orderResponsibility"
                :items="getOfficeStaff"
                @change="inlineSave(props.item)"
                persistent-hint
                item-text="text"
                item-value="id"
                class="avecor-select"
                :disabled="disabledRoleSelection(props.item.id)"
              />
            </td>
            <td>
              <v-text-field
                v-model="props.item.id"
                class="avecor-select"
                disabled
              ></v-text-field>
            </td>
          </tr>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td class="pa-0" :colspan="headers.length">
            <v-row no-gutters>
              <v-col cols="12">
                <v-btn v-if="user.uid==='gRkaRl92OGXQIzaJy9E0YiOKgSf1'" class="avecor-button-global add-button mt-3 " x-small color="#000000" @click="addYear(item)" dark >
                  Lisää vuosi
                  
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters >
              <v-col cols="12" class="pa-2 text-left" ><span class="title">Kate</span></v-col>
            </v-row>
            <v-row no-gutters >
              <v-col cols="1" class="pa-2 text-center" >
                <v-row no-gutters >
                  <v-col  cols="12" style="font-weight:bold" class="pa-2 text-left">Vuosi
                  </v-col>
                </v-row>
                <v-row no-gutters v-for="(year) in years" :key="item.id+'-margin-goal-header'+year">
                  <v-col v-if="item.marginGoals && item.marginGoals[year]" cols="12" class="pa-2 text-center">
                    <v-text-field
                      :value="year"
                      disabled
                      class="avecor-select hide-field-details"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="11" class="pa-2 text-center" >
                <v-row no-gutters style="font-weight:bold">
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Tammikuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Helmikuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Maaliskuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Huhtikuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Toukokuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Kesäkuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Heinäkuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Elokuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Syyskuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Lokakuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Marraskuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Joulukuu</v-col>
                </v-row>
                <v-row no-gutters v-for="(year) in years" :key="item.id+'-sales-goal-'+year">
                  
                    <v-col v-if="item.marginGoals && item.marginGoals[year]" cols="1" class="pa-2" v-for="index in 12" :key="item.id+'-sales-goal-'+index">
                      <v-text-field
                        v-model="item.marginGoals[year][index]"
                        @change="inlineSave(item)"
                        class="avecor-select hide-field-details"
                      ></v-text-field>
                    </v-col>
                  
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters >
              <v-col cols="12" class="pa-2 text-left" ><span class="title">Myynti</span></v-col>
            </v-row>
            <v-row no-gutters >
              <v-col cols="1" class="pa-2 text-center" >
                <v-row no-gutters >
                  <v-col  cols="12" style="font-weight:bold" class="pa-2 text-left">Vuosi
                  </v-col>
                </v-row>
                <v-row no-gutters v-for="(year) in years" :key="item.id+'-sales-goal-header'+year">
                  <v-col v-if="item.goals[year]" cols="12" class="pa-2 text-center">
                    <v-text-field
                      :value="year"
                      disabled
                      class="avecor-select hide-field-details"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="11" class="pa-2 text-center" >
                <v-row no-gutters style="font-weight:bold">
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Tammikuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Helmikuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Maaliskuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Huhtikuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Toukokuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Kesäkuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Heinäkuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Elokuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Syyskuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Lokakuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Marraskuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Joulukuu</v-col>
                </v-row>
                <v-row no-gutters v-for="(year) in years" :key="item.id+'-sales-goal-'+year">
                  
                    <v-col v-if="item.goals[year]" cols="1" class="pa-2" v-for="index in 12" :key="item.id+'-sales-goal-'+index">
                      <v-text-field
                        v-model="item.goals[year][index]"
                        @change="inlineSave(item)"
                        class="avecor-select hide-field-details"
                      ></v-text-field>
                    </v-col>
                  
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters >
              <v-col cols="12" class="pa-2 text-left" ><span class="title">Katekerroin</span></v-col>
            </v-row>
            <v-row no-gutters >
              <v-col cols="1" class="pa-2 text-center" >
                <v-row no-gutters ><v-col cols="12" style="font-weight:bold" class="pa-2 text-left">Vuosi</v-col></v-row>
                <v-row no-gutters v-for="(year) in years" :key="item.id+'-margin-rate-goal-header-'+year">
                  <v-col v-if="item.marginRateGoals[year]" cols="12" class="pa-2 text-center">
                    <v-text-field
                      :value="year"
                      disabled
                      class="avecor-select hide-field-details"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="11" class="pa-2 text-center" >
                <v-row no-gutters style="font-weight:bold">
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Tammikuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Helmikuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Maaliskuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Huhtikuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Toukokuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Kesäkuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Heinäkuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Elokuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Syyskuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Lokakuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Marraskuu</v-col>
                  <v-col cols="1" class="pa-2 text-left" style="font-weight:bold">Joulukuu</v-col>
                </v-row>
                <v-row no-gutters v-for="(year) in years" :key="item.id+'-margin-rate-goal-'+year">
                  <v-col v-if="item.marginRateGoals[year]" cols="1" class="pa-2" v-for="index in 12" :key="item.id+'-margin-rate-goal-'+index">
                    <v-text-field
                      v-model="item.marginRateGoals[year][index]"
                      @change="inlineSave(item)"
                      class="avecor-select hide-field-details"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </td>
        </template>
      </v-data-table>
      </div>
    </div>
    <div v-if="selectedStaffTab === 'signatures'" style="padding-top:30px;">
      <v-row no-gutters>
        <v-col cols="2" class=" pa-0 no-bars" style="max-height:calc(100vh - 66px);height:calc(100vh - 66px);background:#FFF; ;position:relative;border-right:1px solid #ccc;">
          <v-list style="background:#FFF;overflow-y:scroll;height:calc(100%);width:100%;" dark class="orange-scrollbar pt-0 pb-0 mb-0" :key="listKey">
            <v-list-item-group light  v-model="selectedPerson" >
              <div style="border-top:1px solid #ccc;border-bottom:1px solid #ccc; width:100%">
                <span class="ml-4" style="color:#000;font-size:10px;"> <v-icon class="pr-3 pb-1" :size=10 :color="'#666'" >fas fa-users</v-icon>Henkilöt</span>
              </div>
              <v-list-item
                v-for="(u, i) in getStaffForSignatures"
                :value="u.id"
                :key="u.id + '_' + i"
                @click="selectPerson(u.id)"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="u.firstName + ' ' + u.lastName"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <div class="text-right"  style="">
                    <!-- <span style="display:inline-block;width:10px"></span> -->
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on" >
                          <span v-if="allAccess && selectedPerson === u.id" style="display:inline-block;width:14px;" class="px-2" ><v-icon size="12"  @click="saveSignatureToGmail(u.id)" color="#000">fas fa-save</v-icon></span>
                        </span>
                      </template>
                      <span style="font-size:11px;">Tallenna allekirjoitus henkilön Google-tiliin</span>
                    </v-tooltip>
                    
                    
                  </div>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          
          </v-list>
        </v-col>
        <v-col :cols="contentSidebarOpen || imageSidebarOpen ? 6 : 10" :class="'ma-0 pa-0 admin-view-height'" style="">
          <div id="quill-toolbar" v-if="allAccess">
            <button class="ql-bold"></button>
            <select class="ql-size">
              <option selected></option>
              <option class="ql-picker-item" value="8px"></option>
              <option class="ql-picker-item" value="9px"></option>
              <option class="ql-picker-item" value="10px"></option>
              <option class="ql-picker-item" value="11px"></option>
              <option class="ql-picker-item" value="12px"></option>
              <option class="ql-picker-item" value="14px"></option>
              <option class="ql-picker-item" value="16px"></option>
              <option class="ql-picker-item" value="18px"></option>
              <option class="ql-picker-item" value="20px"></option>
              <option class="ql-picker-item" value="24px"></option>
              <option class="ql-picker-item" value="30px"></option>
              <option class="ql-picker-item" value="32px"></option>
              <option class="ql-picker-item" value="36px"></option>
            </select>
            
            <button class="ql-italic"></button>
            <button class="ql-underline"></button>
            <button class="ql-strike"></button>
            <button class="ql-list" value="ordered"></button>
            <button class="ql-list" value="bullet"></button>
            <select class="ql-header">
              <option selected></option>
              <option value="1"></option>
              <option value="2"></option>
              <option value="3"></option>
              <option value="4"></option>
              <option value="5"></option>
              <option value="6"></option>
            </select>
            <select class="ql-color">
              <option selected></option>
              <option class="ql-picker-item" value="#33B9EC"></option>
              <option class="ql-picker-item" value="#666666"></option>
              <option class="ql-picker-item" value="#0072b8"></option>
            </select>
            <select class="ql-background"></select>
            <select class="ql-font"></select>
            <select class="ql-align"></select>
            <button class="ql-link"></button>
            <button class="ql-clean"></button>
            <!-- <button class="ql-image"></button> -->
            
            <button v-if="selectedPerson !== ''" id="custom-button" @click="contentSidebarOpen = false;imageSidebarOpen = !imageSidebarOpen;imageSidebarKey=imageSidebarKey+1" style="font-size:14px;padding-top:2px;"><i class="far fa-image"></i></button>
            <button v-if="selectedPerson !== ''" id="custom-code" @click="addSignatureTemplate()" style="font-size:14px;padding-top:2px;"><i class="fa fa-envelope"></i></button>
            <!-- <button v-if="selectedPerson !== ''" id="custom-button" @click="imageSidebarOpen = false;contentSidebarOpen = !contentSidebarOpen;contentSidebarKey=contentSidebarKey+1" style="font-size:14px;padding-top:2px;"><i class="fas fa-file-pdf"></i></button> -->
            <div v-if="selectedPerson !== ''" class="ml-2" style="display:inline-block;background:orange;line-height:22px; font-size:14px;">Käytetty tila: {{Math.round((content.length / 1046000) * 1000)/10  }} %</div>
          </div>
          <quill-editor :key="quillKey" ref="quillEditor" id="quillEditor"
            style="height:calc(100vh - 110px); "
            :disabled='(!allAccess) || disabled'
            v-model="content"
            :options="editorOption"
            @change="onEditorChange($event)">
          </quill-editor>
        </v-col>
        <!-- <v-col cols="4" v-if="contentSidebarOpen" :key="contentSidebarKey">
          <v-row no-gutters style="padding-top:1px;border-bottom:2px solid #ccc;background:#eee" >
            <v-col cols="2" class="text-left pl-2 pt-2">
              <v-icon @click="contentSidebarOpen = false" style="" size="18" color="#111">fas fa-times</v-icon>
            </v-col>
            <v-col cols="8" class="text-center headline pt-2">
              Valitse PDF
            </v-col>
            <v-col cols="2" class="text-left pl-2"></v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <MediaUpload type="signatureFile" productVariationId="" productId="" />
            </v-col>
            <v-col cols="12" style="overflow-y:scroll;max-height:calc(100vh - 300px);height:calc(100vh - 300px)" class=" orange-scrollbar">
              <MediaGrid :types="['signatureFile']" :actions="['delete','copyUrl','download','select']" @selectedFile="addLink" colsPerItem="3" company="" order="" product="" orderedProduct="" productVariation="" context="information" ref="mediaGrid"></MediaGrid>
            </v-col>
          </v-row>

        </v-col> -->
        <v-col cols="4" v-if="imageSidebarOpen" :key="imageSidebarKey">
          <v-row no-gutters style="padding-top:1px;border-bottom:2px solid #ccc;background:#eee" >
            <v-col cols="2" class="text-left pl-2 pt-2">
              <v-icon @click="imageSidebarOpen = false" style="" size="18" color="#111">fas fa-times</v-icon>
            </v-col>
            <v-col cols="8" class="text-center headline pt-2">
              Kuvat
            </v-col>
            <v-col cols="2" class="text-left pl-2"></v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" >
              <MediaUpload type="signatureImage" productVariationId="" productId="" />
            </v-col>
            <v-col cols="12" class="py-0 my-0 orange-scrollbar" style="overflow-y:scroll;max-height:calc(100vh - 326px);border-bottom:1px solid #ccc;height:calc(100vh - 326px)" >
              <MediaGrid :types="['signatureImage']" :actions="['delete','copyUrl','download','small','medium','large']" @selectedFile="addImage" colsPerItem="3" company="" order="" product="" orderedProduct="" productVariation="" context="signatures" ref="mediaGrid"></MediaGrid>
            </v-col>
          </v-row>

        </v-col>

      </v-row>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
import AddStaff from './AddStaff'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import { Quill } from 'vue-quill-editor'

// --- Whitelist the styles used in the signature template ---

const sizeStyle = Quill.import('attributors/style/size')
sizeStyle.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px']
Quill.register(sizeStyle, true)

const FontStyle = Quill.import('attributors/style/font');
FontStyle.whitelist = ['600', 'bold'];
Quill.register(FontStyle, true);


var Block = Quill.import('blots/block');
Block.tagName = 'div';
Quill.register(Block);


//import { Scope, StyleAttributor } from 'parchment'

//const ColorStyle = new StyleAttributor('color', 'color')
//const ColorStyle = new StyleAttributor('color', 'color', { scope: Scope.INLINE })
//Quill.register(ColorStyle, true)


// --- Enable Quill's native table module ---
/* const table = Quill.import('modules/table');
Quill.register(table, true);

// --- Allow all inline styles ---
const Style = Quill.import('attributors/style/style');
Quill.register(Style, true); */

import axios from 'axios'
import firebase from 'firebase'

var db = null

export default {
    components: {
      AddStaff,
      quillEditor
    },
    data: () => ({
      expandedPersons:[],
      signatureInstructions:'',
      instructionsLoaded:false,
      contentSidebarOpen:false,
      imageSidebarOpen:false,
      imageSidebarKey:4548778,
      contentSidebarKey:4548999,
      quillKey:4781345,
      listKey:5894,
      staffTableKey:124789,
      content: '',
      disabled:true,
      disabledContent:'<p class="ql-align-center"><br></p><p class="ql-align-center"><br></p><p class="ql-align-center"><br></p><p class="ql-align-center"><br></p><p class="ql-align-center"><br></p><p class="ql-align-center"><br></p><p class="ql-align-center"><br></p><p class="ql-align-center"><br></p><p class="ql-align-center"><br></p><p class="ql-align-center"><br></p><h1 class="ql-align-center">Valitse henkilö vasemmalta</h1><p class="ql-align-center"><br></p><p class="ql-align-center"><br></p>',
      editorOption: {
        modules: {
          toolbar:'#quill-toolbar',
          //table: true // Enable the table module in the editor
        }
      },
      selectedStaffTab:'persons',
      selectedPerson:'',
      showExitedStaff:false,
      activeExitFilter:"active",
      isEditing: false,
      years:[2020,2021,2022,2023,2024,2025,2026,2027,2028,2029,2030,2031,2032],//,2022,2023,2024,2025],
      headers: [
        //{ text: '#', value: 'number', align: 'left',},
        //{ text: '', value: 'select', align: 'center', sortable: false},
        { text: ' ', value: 'name', align: 'center', sortable: false },
        { text: 'Lisätty pvm.', value: 'created_at', align: 'center', sortable: true},
        { text: 'Etunimi', value: 'firstName', align: 'left', sortable: true},
        { text: 'Sukunimi', value: 'lastName', align: 'left', sortable: true},
        { text: 'Sähköposti', value: 'email', align: 'left', sortable: true},
        { text: 'Puhelinnumero', value: 'phone', align: 'left', sortable: true},
        { text: 'Osoite', value: 'address', align: 'left', sortable: true},
        { text: 'Netvisor Id', value: 'netvisorKey', align: 'left', sortable: true},
        { text: 'IT-laitteet', value: 'deviceInfo', align: 'left', sortable: true},
        { text: 'Rooli', value: 'roles', align: 'left', sortable: true},
        { text: 'Admin', value: 'isAdmin', align: 'left', sortable: true},
        { text: 'Exit', value: 'isExit', align: 'left', sortable: true},
        { text: 'Disabloi Raportti näkymä', value: 'disableReportView', align: 'left', sortable: true},
        { text: 'Disabloi Tilaukset näkymä', value: 'disableOrdersView', align: 'left', sortable: true},
        { text: 'Viikko raportointi?', value: 'weekReportingRequired', align: 'left', sortable: true},
        //{ text: 'Tarjoukset näkymä', value: 'promotions', align: 'left', sortable: true},
        { text: 'Tuotteet näkymä', value: 'products', align: 'left', sortable: true},
        { text: 'Henkilöstö näkymä', value: 'staff', align: 'left', sortable: true},
        { text: 'Kaikkien katteet (sales)', value: 'margins', align: 'left', sortable: true},
        { text: 'Kaikkien tilaukset (sales)', value: 'allOrders', align: 'center', sortable: true},
        { text: 'Kaikki tiedostot (sales)', value: 'allFiles', align: 'center', sortable: true},
        //{ text: 'Myynti Devi Ympäristö', value: 'salesDev', align: 'left', sortable: true},
        //{ text: 'Office Devi Ympäristö', value: 'officeDev', align: 'left', sortable: true},
        { text: 'Tilauksista vastaava', value: 'orderResponsibility', align: 'left', sortable: true},
        //{ text: 'Tuotekoodi', value: 'sku', align: 'left', sortable: true},
        { text: 'Avecor Id', value: 'orderId', align: 'left', sortable: true},
      ],
      editedIndex: -1,
      addedDatePickerMenuMaster: false,
      date: new Date().toISOString().substr(0, 10),
      addStaffDialog:false
    }),
    watch: {
      
      instructionsLoaded:{
        handler(val){
          if(val) {
            console.log("LOADED INS")
            this.selectPerson('instructions')
          }
        }
      }
    },
    mounted() {
      this.content = this.disabledContent
      db = firebase.firestore();
      this.initiateSignatureInstructions()
    },    
    computed: {
      allAccess(){
        return this.staff[this.user.uid] !== undefined && (this.staff[this.user.uid].isAdmin || this.staff[this.user.uid].role == 'office' || this.staff[this.user.uid].role == 'warehouse')
      },
      getStaff(){
        var staff = this.staff
        var staffToReturn = []
        Object.keys(this.staff).forEach(key => {
          var person = this.staff[key]
          var text = person.firstName.toLowerCase() + person.lastName.toLowerCase()
          if(this.staffSearchTerm !== '' && text.includes(this.staffSearchTerm)) {
            if(this.activeExitFilter === "exited"){
              if(person.isExit) staffToReturn.push(person)
            }
            else {
              if(!person.isExit) staffToReturn.push(person)
            }
          }
          else if(this.staffSearchTerm === '') {
            if(this.activeExitFilter === "exited"){
              if(person.isExit) staffToReturn.push(person)
            }
            else {
              if(!person.isExit) staffToReturn.push(person)
            }
          }
          
        })
        staffToReturn = staffToReturn.sort((a,b)=>{
          var nameA=a.firstName.toLowerCase().trim() + a.lastName.toLowerCase().trim(), nameB=b.firstName.toLowerCase().trim() + b.lastName.toLowerCase().trim();
          if (nameA > nameB) {return 1;}
          if (nameB > nameA) {return -1;}
          return 0;
        })
        
        return staffToReturn
      },
      getStaffForSignatures(){
        var staffToReturn = []
        //staffToReturn.push(this.staff['gRkaRl92OGXQIzaJy9E0YiOKgSf1'])
        Object.keys(this.staff).forEach(key => {
          if(!this.staff[key].isExit) staffToReturn.push(this.staff[key])
        })
        staffToReturn = staffToReturn.sort((a,b)=>{
          var nameA=a.firstName.toLowerCase().trim() + a.lastName.toLowerCase().trim(), nameB=b.firstName.toLowerCase().trim() + b.lastName.toLowerCase().trim();
          if (nameA > nameB) {return 1;}
          if (nameB > nameA) {return -1;}
          return 0;
        })
        staffToReturn.unshift({id:'instructions',firstName:'Ohjeet',lastName:''})
        return staffToReturn
      },
      getOfficeStaff(){
        var staff = this.staff
        var officeStaff = []
        Object.keys(this.staff).map(function(key, index) {
          var s = staff[key]
          if (s.role.includes('office')) officeStaff.push({text:s.firstName, id:s.id})
          
          return s
        })
        return officeStaff
      },
      
      getSalespeople(){
        var staff = this.staff
        var salespeople = []
        Object.keys(this.staff).map(function(key, index) {
          var s = staff[key]
          if (s.role.includes("sales")) salespeople.push({text: s.firstName, id: s.id})
        })
        return salespeople
      },
      ...mapFields([
        "settings",
        "user",
        "settings.staffSearchTerm",
        "views.salesConsole",
        "staff.staff",
      ])
    },
    created () {
    },

    methods: {
      timer(ms) { return new Promise(res => setTimeout(res, ms)); },
      async setPersons(){
        this.selectedStaffTab = '';
        await this.timer(10);
        this.selectedStaffTab = 'persons' 
      },
      async saveSignatureToGmail(id){
        console.log("HERE")
        var userEmail = this.staff[id].email
        var signature = this.staff[id].signature
        signature = '<div style="line-height:1.4em;color:#222">' + signature + '</div>'
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Tallennetaan henkilön sähköpostiin...", snackButtonText: "", errorType:"", snackColor:'deep-blue',right:true,top:true})
        try{
          var url = this.settings.dev ? 'http://0.0.0.0:5000/logogear-erp/us-central1/setSignatures': 'https://us-central1-logogear-erp.cloudfunctions.net/setSignatures'
          let res = await axios.post(url,
            { userEmail, signature },
          );
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        }
        catch(e){
          console.log(e.response.data.message)
          var msg = e.response && e.response.data && e.response.data.message ? e.response.data.message : e.message
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:4000, snackText:msg, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
        }

      },
      addSignatureTemplate(){
        var person = this.staff[this.selectedPerson]
        var code = ''
        

        if(person.email === 'tomi@logogear.fi') code += `<p><b><span style="font-size:18px;color: rgb(51, 185, 236);">${person.firstName}</span></b></p>`
        else code += `<p><b><span style="font-size:18px;color: rgb(51, 185, 236);">${person.firstName} ${person.lastName}</span></b></p>`
        if(person.email === 'miko@logogear.fi') code += `<p><span style="font-size:12px;color:#666666;">Toimitusjohtaja | Logogear Oy</span></p>`
        if(person.email === 'tomi@logogear.fi') code += `<p><span style="font-size:12px;color:#666666;">Digital Development | Logogear Oy</span></p>`

        code += `<br>`
        

        /* code += '<div style="overflow: auto;">'

        // Image div, floated to the left
        let imageUrl = 'https://storage.googleapis.com/logogear_public/logos/logogear_miko_kuva.png'
        if (person.email === 'miko@logogear.fi') {
          imageUrl = 'https://storage.googleapis.com/logogear_public/logos/logogear_miko_kuva.png'
        if (imageUrl) {
          code += `<div style="float: left; margin-right: 10px;"><img src="${imageUrl}" width="128" height="128"/></div>`
        }

        // Text content div
        code += '<div style="overflow: hidden; vertical-align: top;">'
        if(person.phone) code += `📞 <a style="font-size:12px;color:#0072b8;" href="tel:${person.phone}">${person.phone}</a>` + "<br>"
        code += `📞 <a style="font-size:12px;color:#0072b8;" href="tel:0102000670">010 200 0670</a>` + "<br>"
        code += `✉️ <a style="font-size:12px;color:#0072b8;" href="mailto:${person.email}">${person.email}</a><br>`
        if(person.email === 'miko@logogear.fi') code += `🔗 <a style="font-size:12px;color:#0072b8;" href="https://fi.linkedin.com/in/miko-kahlos-b7206686">LinkedIn</a>`
        code += '</div>'

        // Close the container div
        code += '</div>' */





        
        // Reverting to a robust table layout for side-by-side view
        
        // Image Column
        let imageUrl = null;
        if(person.email === 'miko@logogear.fi') imageUrl = 'https://storage.googleapis.com/logogear_public/logos/logogear_miko_kuva.png';
        if(imageUrl){
          code += `<div>__START_KUVA__</div>`
          code += `<div style="vertical-align: top; padding-right: 10px;"><img src="${imageUrl}" width="128" height="128"/></div>`;
          code += `<div>__END_KUVA__</div>`

          code += `<div>__START_LINKIT__</div>`
          if(person.phone) code += `<div>📞 <a style="font-size:12px;color:#0072b8;" href="tel:${person.phone}">${person.phone}</a></div>`
          code += `<div>📞 <a style="font-size:12px;color:#0072b8;" href="tel:0102000670">010 200 0670</a></div>`
          code += `<div>✉️ <a style="font-size:12px;color:#0072b8;" href="mailto:${person.email}">${person.email}</a></div>`
          if(person.email === 'miko@logogear.fi') code += `<div>🔗 <a style="font-size:12px;color:#0072b8;" href="https://fi.linkedin.com/in/miko-kahlos-b7206686">LinkedIn</a></div>`
          code += `<div>__END_LINKIT__</div>`
        }
        else {
          if(person.phone) code += `<div>📞 <a style="font-size:12px;color:#0072b8;" href="tel:${person.phone}">${person.phone}</a></div>`
          code += `<div>📞 <a style="font-size:12px;color:#0072b8;" href="tel:0102000670">010 200 0670</a></div>`
          code += `<div>✉️ <a style="font-size:12px;color:#0072b8;" href="mailto:${person.email}">${person.email}</a></div>`
          if(person.email === 'miko@logogear.fi') code += `<div>🔗 <a style="font-size:12px;color:#0072b8;" href="https://fi.linkedin.com/in/miko-kahlos-b7206686">LinkedIn</a></div>`
        }

        code += `<br>`
        code += '<div><img src="https://storage.googleapis.com/logogear_public/logos/logo_logogear_blue_small.png" width="150" height="35"/></div>'
        //code += `<div><span style="font-size:14px;color:#33B9EC;text-decoration:underline;"><a href="https://logogear.fi">www.logogear.fi</a></span></div>`
        code += `<div><span style="font-size:14px;color:#33B9EC;text-decoration:underline;"><u>www.logogear.fi</u></span></div>`
        //email += `<br>`
        code += `<p><span style="color:#33B9EC;font-size:14px;" ><b>────────────────</b></span></p>`
        //email += `<br>`
        code += `<p><span style="color:#666666;font-size:14px;" ><b>Logogear Oy</b></span></p>`
        code += `<p><span style="color:#666666;font-size:12px;" >Keilaranta 1, 02150 Espoo, FIN</span></p>`
        code += `<p><span style="color:#666666;font-size:12px;" >Y-tunnus: 3546089-1</span></p>`

        code += `<p><span style="color:#33B9EC;font-size:12px;font-style:italic;" ><b>Moderni liikelahjaverkkokauppa - tehokas, nopea, vaivaton.</b></span></p>`
        code += "<br>"
        code += '<div><img src="https://storage.googleapis.com/logogear_public/logos/trusted_partner_green_small.png" width="136" height="60"/></div>'


        /* if(this.selectedPerson !== ""){
          this.$store.dispatch('staff/set', {
            id:this.selectedPerson,
            signature:code,
          })
          //.then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        }

        return */


        console.log(code)
        
        var quill = this.$refs['quillEditor'].quill
        //quill.focus();
        //Keep font formatting (size, color) ? 
        quill.clipboard.addMatcher('FONT', function(node, delta) {
          console.log('HOW FONTY');
          return delta;
        });
        /* var caretPosition = quill.getSelection(true);
        quill.clipboard.dangerouslyPasteHTML(caretPosition.index, code); */

        console.log("HEELL")
        /* const delta = quill.clipboard.convert(code)
        quill.setContents(delta, 'silent') */

        //quill.root.innerHTML = code
        //quill.setHTML(code)
        quill.pasteHTML(code)

        /* var editor = document.getElementsByClassName('ql-editor')
        console.log(editor[0])
        editor[0].innerHTML = code
        console.log(editor[0].innerHTML) */

        // "<p><strong><span style="font-size:18px;color: rgb(51, 185, 236);">Tomi Hokkanen</span></strong></p><p><span style="font-size:12px;color:#666666;">Toimitusjohtaja | Logogear Oy</span></p><div><br></div><div><br></div><div><span style="font-size:14px;color:#33B9EC;text-decoration:underline;"><u>www.logogear.fi</u></span></div><p><span style="color:#33B9EC;font-size:14px;"><b>────────────────</b></span></p><p><span style="color:#666666;font-size:14px;"><b>Logogear Oy</b></span></p><p><span style="color:#666666;font-size:12px;">Keilaranta 1, 02150 Espoo, FIN</span></p><p><span style="color:#666666;font-size:12px;">Y-tunnus: 3546089-1</span></p><p><span style="color:#33B9EC;font-size:12px;font-style:italic;"><b>Moderni liikelahjaverkkokauppa - tehokas, nopea, vaivaton.</b></span></p><div><br></div><div><img src="https://storage.googleapis.com/logogear_public/logos/trusted_partner_green_small.png" width="136" height="60"></div>"
      },
      addImage(fileUrl){
        console.log("HELLO")
        
        fileUrl = fileUrl.replace("https://firebasestorage.googleapis.com/v0/b/avecor-public/o/","https://storage.googleapis.com/avecor-public/")
        fileUrl = fileUrl.replace("https://firebasestorage.googleapis.com/v0/b/avecor-internal/o/","https://storage.googleapis.com/avecor-internal/")
        fileUrl = fileUrl.split('?')[0]
        var quill = this.$refs['quillEditor'].quill
        quill.focus();
        var caretPosition = quill.getSelection(true);
        quill.insertEmbed(caretPosition.index, 'image', fileUrl);
      },
      selectPerson(id){
        
        var self = this
        if (this.selectedPerson === id) {
          setTimeout(() =>{self.selectedPerson=null;self.selectedPerson=id}, 100);
          return
        }
        this.selectedPerson=null;
        setTimeout(() =>{
          if(id === 'instructions'){
            console.log("INSTUR")
            this.selectedPerson = id
            self.content = this.signatureInstructions
            self.disabled = false
          }
          else{
            //this.quillKey = this.quillKey + 1
            this.selectedPerson = id
            self.content = self.staff[id].signature ? self.staff[id].signature : ''
            self.disabled = false
          }
        }, 200);
      },
      onEditorChange(event) {
        try{
          if(event.html.length > 1046000){
            this.quillKey = this.quillKey + 1
            alert('Muistiinpanon koko on ylittänyt maksimin (1 megatavun). Viimeisintä lisäystä ei voida tallentaa.')
            var id = this.selectedPerson
            this.emptySelections()
            this.selectPerson(id)
            return
          }
          else {
            if(this.selectedPerson === 'instructions'){
              var html = event.html
              db.collection('config').doc("signatureInstructions").set({
                id:'signatureInstructions',
                content:html
              }, { merge: true })
              /* .then(function() {
                this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
              }) */
            }
            else {
              var html = event.html
              //html = html.replace(/<p>/g,"<div>")
              //html = html.replace(/<\/p>/g,"</div>")
              if(this.selectedPerson !== ""){
                this.$store.dispatch('staff/set', {
                  id:this.selectedPerson,
                  signature:html,
                })
                //.then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
              }
            }
          }
        }
        catch(e){
          //console.log(e)
        }
      },
      addMarginGoals(){
        var years = [2023,2024,2025]//,2026,2027,2028,2029,2030,2031,2032]
        var salespeople = this.getSalespeople
        console.log(salespeople)
        salespeople.forEach(s => {
          var salesperson = this.staff[s.id]
          let {marginGoals, ...y} = salesperson;  
          
          if(!marginGoals) marginGoals= {}
          years.forEach(y => {
            if(!marginGoals[y]){
              marginGoals[y] = {
                "1":0,
                "2":0,
                "3":0,
                "4":0,
                "5":0,
                "6":0,
                "7":0,
                "8":0,
                "9":0,
                "10":0,
                "11":0,
                "12":0,
              }
            }
          })
          this.$store.dispatch('staff/set', {
            id:s.id,
            marginGoals,
          }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
          console.log(marginGoals)
        })
      },
      addYear(item){
        var lys = 2020
        var lyr = 2020
        var lym = 2020
        let {id, goals, marginRateGoals, marginGoals, ...y} = item;
        Object.keys(goals).forEach(k => {
          var y = Number(k)
          if (lys < y) lys = y
        })
        Object.keys(marginRateGoals).forEach(k => {
          var y = Number(k)
          if (lyr < y) lyr = y
        })
        Object.keys(marginGoals).forEach(k => {
          var y = Number(k)
          if (lym < y) lym = y
        })

        lyr = lyr + 1
        lys = lys + 1
        lym = lym + 1
        console.log({lyr,lys,lym})
        
        var copyGoals = JSON.parse(JSON.stringify(goals))
        var copymarginRateGoals = JSON.parse(JSON.stringify(marginRateGoals))
        var copymarginGoals = JSON.parse(JSON.stringify(marginGoals))

        copyGoals[lys] = {
          "1":0,
          "2":0,
          "3":0,
          "4":0,
          "5":0,
          "6":0,
          "7":0,
          "8":0,
          "9":0,
          "10":0,
          "11":0,
          "12":0,
        }
        copymarginRateGoals[lyr] = {
          "1":0,
          "2":0,
          "3":0,
          "4":0,
          "5":0,
          "6":0,
          "7":0,
          "8":0,
          "9":0,
          "10":0,
          "11":0,
          "12":0,
        }
        copymarginGoals[lym] = {
          "1":0,
          "2":0,
          "3":0,
          "4":0,
          "5":0,
          "6":0,
          "7":0,
          "8":0,
          "9":0,
          "10":0,
          "11":0,
          "12":0,
        }

        console.log({copyGoals,copymarginRateGoals})
        this.$store.dispatch('staff/set', {
          id,
          goals:copyGoals,
          marginRateGoals:copymarginRateGoals,
          marginGoals:copymarginGoals
        }).then(
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        )
      },
      disabledRoleSelection (id){
          if (id === "y9ZVH4HpzFWuS9TzONQUJadQZ4T2" || id === "gRkaRl92OGXQIzaJy9E0YiOKgSf1") return true
          else return false
      },
      customFormatter(date) {
        if (date.seconds) {
          var myDate = new Date(date.seconds*1000);
          return dateFormat(myDate, "yyyy-mm-dd")
        }
        else if (date !== undefined && date.seconds === undefined){
          return dateFormat(date, "yyyy-mm-dd")
        }
        return ''
      },
      deleteItem (item) {
        if (confirm('Do you want to delete?')) {
              this.$store.dispatch('staff/delete', item.id)
        }
      },
      inlineSaveNew(id,field,value){
        console.log({id,field,value})
        if(field.includes('commissionRate')) {
          value = value.replace(",",".")
          if(value == '') value = value
          else if(!isNaN(Number(value))) value = Number(value)
          else {
            alert("Syötä luku")
            return
          }
        }
        this.$store.dispatch('staff/set', {
          id,
          [field]:value
        }).then(
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        )
      },
      inlineSave (item) {
        let {id, ...y} = item;
        this.$store.dispatch('staff/set', {
          id,
          ...y
        }).then(
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
          )
      },
      async inlineSaveGoalData(sId,selectedGoals, year,month,v, isInputField){
        
        if(isInputField) v = v.target.value
        v = v.replace(",",".")
        if(isNaN(Number(v))){
          alert("Syötä luku")
          this.staffTableKey += 1
          return
        }
        v = Number(v)
        console.log({sId,selectedGoals, year,month,v})
        var copyGoals = JSON.parse(JSON.stringify(this.staff[sId][selectedGoals]))
        copyGoals[year][month] = v
        
        console.log(this.staff[sId][selectedGoals])

        console.log(copyGoals)

        await this.$store.dispatch('staff/set', {
          id:sId,
          [selectedGoals]:copyGoals
        })
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      },
      initiateSignatureInstructions(){
        var t= this
        if(this.allAccess){
          db.collection("config").doc("signatureInstructions")
            .onSnapshot((doc) => {
              t.instructionsLoaded = true
              console.log("HELLO")
              var data = doc.data()
              t.signatureInstructions = data.content
            });
        }
      }
    }
  }
</script>

<style>
.ql-editor ol li:not(.ql-direction-rtl), .ql-editor ul li:not(.ql-direction-rtl) {
    padding-left: unset !important;
}
/* .ql-editor ol li {
    counter-reset: unset !important;
    counter-increment: unset !important;
} */
.ql-editor ol li:before {
    content: unset !important;
}
.admin-view-height{
  max-height:calc(100vh - 110px);height:calc(100vh - 110px);
}

</style>


// WEBPACK FOOTER //
// src/components/blocks/StaffTable.vue